import axios from 'axios'
import { apiBaseUrl } from '@/variables/localVariables'
import store from '@/store/store'
import router from '@/router'

const axios_instance = axios.create({
  baseURL:apiBaseUrl,
});

var isRefreshing = false

//Add a response interceptor
axios_instance.interceptors.response.use(
  function (response) {
    store.dispatch('AUTH_INSPECT')
      .catch(() => {
        store.commit('AUTH_LOGOUT')
        router.push('/login')
      })
    return response
  },
  function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && originalRequest.url === apiBaseUrl +'/auth/token/refresh') {
     router.push('/login');
     return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true
        originalRequest._retry = true
        const refreshToken = JSON.parse(store.state.auth.token).refresh

        return axios_instance.post(apiBaseUrl +'/auth/token/refresh', {"refresh": refreshToken})
         .then(res => {
           if (res.status === 200) {
             store.commit('AUTH_REFRESH', res.data)
             originalRequest.headers['Authorization'] = 'Bearer ' + res.data.access
             return axios_instance(originalRequest)
           }
           else {
             store.commit('AUTH_LOGOUT')
             router.push('/login')
           }
         })
         .catch(() => {
           store.commit('AUTH_LOGOUT')
           router.push('/login')
         })
         .finally(() => {
           isRefreshing = false
         })
     }
     originalRequest.headers['Authorization'] = 'Bearer ' + JSON.parse(store.state.auth.token).access
     return axios_instance(originalRequest)
   }
   return Promise.reject(error)
});

export class APIDomain {

  createDomain (token, domain_name, iframe_connexion_id, login, name, password, type, url_login,
                xpath_clics, xpath_login, xpath_password, xpath_button) {

    const url = apiBaseUrl + `/create-domain`

    var headers = {
      'Authorization': 'Bearer '+ JSON.parse(token).access,
      'Content-Type': 'application/json'
    }
    var data = {
      'domain_name': domain_name,
      "iframe_connexion_id": iframe_connexion_id,
      'login': login,
      'name': name,
      'password': password,
      'type': type,
      'url_login': url_login,
      'xpath_clics': xpath_clics,
      'xpath_login': xpath_login,
      'xpath_password': xpath_password,
      'xpath_button': xpath_button,
    }

    return axios_instance.post(
      url, data,
      {
        'headers': headers,
      }
    )
  }

  getAllDomains(token) {
    const url = apiBaseUrl + `/domains`
    var headers = {
      'Authorization': 'Bearer '+ JSON.parse(token).access,
      'Content-Type': 'application/json',
    }
    return axios_instance.get(url, {'headers': headers,})
  }

  getDomain(token, id) {
    const url = apiBaseUrl + `/domain/` + String(id)
    var headers = {
      'Authorization': 'Bearer '+ JSON.parse(token).access,
      'Content-Type': 'application/json',
    }
    return axios_instance.get(url, {'headers': headers,})
  }


  modifyDomain (token, id, active, domain_name, iframe_connexion_id, login, name, password, type, url_login,
                xpath_clics, xpath_login, xpath_password, xpath_button) {

    const url = apiBaseUrl + `/domain/` + String(id)
    var headers = {
      'Authorization': 'Bearer '+ JSON.parse(token).access,
      'Content-Type': 'application/json'
    }
    var data = {
      'active': active,
      'domain_name': domain_name,
      "iframe_connexion_id": iframe_connexion_id,
      'login': login,
      'name': name,
      'password': password,
      'type': type,
      'url_login': url_login,
      'xpath_clics': xpath_clics,
      'xpath_login': xpath_login,
      'xpath_password': xpath_password,
      'xpath_button': xpath_button,
    }

    return axios_instance.put(
      url, data,
      {
        'headers': headers,
      }
    )
  }

  toggleDomainActive (token, id, active) {
    const url = apiBaseUrl + `/domain/` + String(id)
    var headers = {
      'Authorization': 'Bearer '+ JSON.parse(token).access,
      'Content-Type': 'application/json'
    }
    return axios_instance.patch(url, { active }, { headers })
  }

  deleteDomain (token, id) {

    const url = apiBaseUrl + `/domain/` + String(id)
    var headers = {
      'Authorization': 'Bearer '+ JSON.parse(token).access,
      'Content-Type': 'application/json'
    }

    return axios_instance.delete(
      url,
      {
        'headers': headers,
      }
    )
  }


  testDomain (token, id) {

    const url = apiBaseUrl + `/test-domain/` + String(id)
    var headers = {
      'Authorization': 'Bearer '+ JSON.parse(token).access,
      'Content-Type': 'application/json'
    }

    return axios_instance.get(
      url,
      {
        'headers': headers,
        'responseType': 'blob', // important
      }
    )
  }
}
